import EventEmitter from './event-emitter';
import ApiManager from './api-manager';
import { TaskManager } from './task-manager';
import SecurityManager from './securities/security-manager';
import Pull from './pull';
import Stream from './stream';
import News from './news';
import TimeSeries from './time-series';
import StaticData from './static-data';
import Options from './options';
import Bonds from './bonds';
import AutoComplete from './autocomplete';
import TimeSales from './time-sales';
import Track from './track';
import Permissions from './permissions';
import Alert from './alert';
import Research from './research';
import Videos from './videos';
import Documents from './documents';
import Download from './download';
import { DATA_EVENTS, PULLING_FREQUENCY } from './constant';
import { extend } from '../util/jquery';

export default class DataManager extends EventEmitter {
    constructor() {
        super();
        this.option = {
            frequency: PULLING_FREQUENCY
        };
        this.apiManager = new ApiManager();
        this.apiManager
            .on(DATA_EVENTS.TOKEN_EXPIRED, (option, callback) => {
                this.emit(DATA_EVENTS.TOKEN_EXPIRED, option, callback);
            })
            .on(DATA_EVENTS.TOKEN_RENEWED, option => {
                extend(this.option, option);
                // When the session updated, we need clear the history cache.
                this.permissions.clearCache();
                this.stream.setOption({
                    sessionId: option.sessionId,
                    accessToken: option.accessToken
                });
            });

        this.securityManager = new SecurityManager({
            apiManager: this.apiManager
        });
    }
    getOption() {
        return this.option;
    }
    setOption(option) {
        extend(this.option, option);
        this.apiManager.setOption(this.option);
        this.track = new Track({
            apiManager: this.apiManager
        });
        this.pull = new Pull({
            frequency: this.option.frequency,
            taskManager: new TaskManager(),
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.stream = new Stream({
            env: this.option.env,
            sessionId: this.option.sessionId,
            accessToken: this.option.accessToken,
            userId: this.option.userId,
            overridePaths: this.option.overridePaths,
            apiManager: this.apiManager,
            securityManager: this.securityManager,
            migratoryDataClient: this.option.migratoryDataClient
        });
        this.news = new News({
            apiManager: this.apiManager
        });
        this.options = new Options({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.timeSeries = new TimeSeries({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.staticData = new StaticData({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.bonds = new Bonds({
            apiManager: this.apiManager
        });
        this.autocomplete = new AutoComplete({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.permissions = new Permissions({
            apiManager: this.apiManager
        });
        this.timeSales = new TimeSales({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.alert = new Alert({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.research = new Research({
            apiManager: this.apiManager,
            securityManager: this.securityManager
        });
        this.videos = new Videos({
            apiManager: this.apiManager
        });
        this.documents = new Documents({
            apiManager: this.apiManager
        });
        this.download = new Download({
            apiManager: this.apiManager
        });
    }
    connectPull() {
        return this.pull.connect();
    }
    connectStream() {
        return this.stream.connect();
    }
}
